import { FormattedMessage } from "react-intl";

import { RanaModal } from "@nens/ranalib";

export const ResetPublicationModal = ({
  isOpen,
  reset,
  onClose,
}: {
  isOpen: boolean;
  reset: () => void;
  onClose: () => void;
}) => {
  return (
    <RanaModal
      topBar={
        <FormattedMessage
          id="header.leave_page"
          defaultMessage="Do you really want to discard all changes?"
        />
      }
      onClose={onClose}
      buttons={[
        {
          children: <FormattedMessage id="common.cancel" defaultMessage="Cancel" />,
          variant: "secondary",
          onClick: onClose,
        },
        {
          children: <FormattedMessage id="common.yes" defaultMessage="Yes" />,
          variant: "danger",
          onClick: () => {
            reset();
            onClose();
          },
        },
      ]}
      isOpen={isOpen}
    >
      <FormattedMessage
        id="publication.reset_publication_version_warning"
        defaultMessage="This will discard all unsaved changes and cannot be undone."
      />
    </RanaModal>
  );
};
